import { atomWithStorage } from 'jotai/utils';
import { rawNumberStorage } from './storage';

export const companyIdAtom = atomWithStorage<number | null>('companyId', null, rawNumberStorage, { getOnInit: true });
export const projectIdAtom = atomWithStorage<number | null>('projectId', null, rawNumberStorage, { getOnInit: true });
